module.exports = __webpack_public_path__ + "media/ferulic-large.947c4f57.mp4";